import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation TrackEvent($name: String!, $attributes: JSON) {
    trackUserEvent(name: $name, attributes: $attributes) {
      id
    }
  }
`;

export const trackUserEvent = (name: string, attributes: object) => {
  const variables = {
    name,
    attributes: stringifyIfPresent(attributes),
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
